import FeatureGates from '@atlaskit/feature-gate-js-client';

export const isTeamBiDirectionalEnabled = (
	containerType?: string,
	fireExperimentExposure: boolean = false,
): boolean => {
	if (FeatureGates.initializeCompleted()) {
		return (
			containerType === 'Jira' ||
			(containerType === 'Confluence' &&
				FeatureGates.getExperimentValue(
					'edit-team-connection-from-confluence',
					'isEnabled',
					false,
					{
						fireExperimentExposure,
					},
				))
		);
	}

	return false;
};
